import React from "react";
import Dispatcher from "../dispatcher";
import UserStore from "../stores/user-store";
import UserAction from "../actions/user-action";
import Utils from "../utils/utils";
import {
  VstLoader,
  VstToastUtils
} from "vstui";
import { Button, Dialog, TextField, Select } from "@vitalsource/vstui";
import FormAlert from './form-alert';

const User = React.createClass({
  getInitialState() {
    let state = this._getUserObject(UserStore.get());
    return state;
  },

  componentDidMount() {
    Dispatcher.on(Dispatcher.USER_STORE_CHANGE, this._handleChange);
    Dispatcher.on(Dispatcher.USER_UPDATE_SUCCESS, this._handleSetInfoSuccess);
    Dispatcher.on(
      Dispatcher.USER_CHANGE_PASSWORD_SUCCESS,
      this._handleChangePasswordSuccess
    );
    Dispatcher.on(
      Dispatcher.USER_UPDATE_SECURITY_SUCCESS,
      this._handleSecuritySuccess
    );
    Dispatcher.on(Dispatcher.USER_UPDATE_FAILURE, this._handleSetInfoFailure);
    Dispatcher.on(
      Dispatcher.USER_CHANGE_PASSWORD_FAILURE,
      this._handleChangePasswordFailure
    );
    Dispatcher.on(
      Dispatcher.USER_UPDATE_SECURITY_FAILURE,
      this._handleSecurityFailure
    );
  },

  componentWillUnmount() {
    Dispatcher.removeListener(Dispatcher.USER_STORE_CHANGE, this._handleChange);
    Dispatcher.removeListener(
      Dispatcher.USER_UPDATE_SUCCESS,
      this._handleSetInfoSuccess
    );
    Dispatcher.removeListener(
      Dispatcher.USER_CHANGE_PASSWORD_SUCCESS,
      this._handleChangePasswordSuccess
    );
    Dispatcher.removeListener(
      Dispatcher.USER_UPDATE_SECURITY_SUCCESS,
      this._handleSecuritySuccess
    );
    Dispatcher.removeListener(
      Dispatcher.USER_UPDATE_FAILURE,
      this._handleSetInfoFailure
    );
    Dispatcher.removeListener(
      Dispatcher.USER_CHANGE_PASSWORD_FAILURE,
      this._handleChangePasswordFailure
    );
    Dispatcher.removeListener(
      Dispatcher.USER_UPDATE_SECURITY_FAILURE,
      this._handleSecurityFailure
    );
  },

  _handleChange() {
    this.setState(this._getUserObject(UserStore.get()));
  },

  _handleSetInfoSuccess() {
    this._hideModal();
    VstToastUtils.notify(i18n.t("user.info-updated"), {
      type: "success",
      horizontalPosition: "right",
    });
    this.setState({ settingInfo: false });
  },

  _handleChangePasswordSuccess() {
    this._hideModal();
    VstToastUtils.notify(i18n.t("user.password-updated"), {
      type: "success",
      horizontalPosition: "right",
    });
    this.setState({ updatingPassword: false });
  },

  _handleSecuritySuccess() {
    this._hideModal();
    VstToastUtils.notify(i18n.t("user.security-updated"), {
      type: "success",
      horizontalPosition: "right",
    });
    this.setState({ updatingSecurity: false });
  },

  _handleSetInfoFailure() {
    this.setState({
      setInfoError:
        i18n.t("user.error-updating-info"),
      settingInfo: false
    });
  },

  _handleChangePasswordFailure(response) {
    if (response && response.errors) {
      if (
        response.errors.current_password &&
        response.errors.current_password.indexOf("is not correct") !== -1
      ) {
        this.setState({
          passwordChangeError: i18n.t("user.incorrect-password"),
          updatingPassword: false
        });
      } else if (
        response.errors.password &&
        response.errors.password.indexOf(
          "password can not be the same as the previous password"
        ) !== -1
      ) {
        this.setState({
          passwordChangeError: i18n.t("user.password-cannot-be-same"),
          updatingPassword: false
        })
      }
    }
  },

  _handleSecurityFailure() {
    this.setState({ 
      securityError: i18n.t("user.error-updating-info"), 
      updatingSecurity: false 
    });
  },

  _getUserObject(user) {
    if (user) {
      return {
        user: user,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        questionId: user.questionId || ""
      };
    } else {
      return { user: false };
    }
  },

  _isValidPassword(password) {
    return !(
      password.length < 8 ||
      !(
        password.match(/[A-Z]/) &&
        password.match(/[a-z]/) &&
        password.match(/[~!@#\$%\^&*\(\)_\-\+=\|\}\]\{\[:;"',\.\?\/<>]/)
      )
    );
  },

  _onSubmit(e) {
    e.preventDefault();
    UserAction.setInfo({
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      email: this.email ? this.email.value : this.state.email
    });
    this.setState({ setInfoError: false, settingInfo: true })
    return false;
  },

  _onUpdatePassword(e) {
    e.preventDefault();
    if (!this.state.updatingPassword) {
      UserAction.changePassword({
        password: this.password.value,
        passwordConfirmation: this.passwordConfirmation.value,
        currentPassword: this.currentPassword ? this.currentPassword.value : "not-required"
      });
      this.setState({ passwordChangeError: false, updatingPassword: true })
    }
    return false;
  },

  _onUpdateSecurityQuestion(e) {
    e.preventDefault();
    if (!this.state.updatingSecurity) {
      UserAction.updateSecurityQuestion({
        questionId: this.questionId.value,
        questionResponse: this.questionResponse.value
      });
      this.setState({ securityError: false, updatingSecurity: true })
    }
    return false;
  },

  _changePassword(e) {
    e.preventDefault();
    Routes.setRoute("user/profile/change-password");
  },

  _changeSecurityQuestion(e) {
    e.preventDefault();
    Routes.setRoute("user/profile/change-security-question");
  },

  _hideModal(_e) {
    Routes.setRoute("/");
  },

  _toggleEmailLockedModal() {
    this.setState({ emailLockedModal: !this.state.emailLockedModal });
  },

  render() {
    if (this.state.user && this.state.user.ssoOnly) {
      let completeAccountUrl = encodeURIComponent(
        Mulligan.Brand.endpoint + "/user/sso?after=" + window.location
      );
      return (
        <div className="page user">
          <h1>{i18n.t("base.user")}</h1>
          <p>
            {Utils.toHTML(
              i18n.t("user.complete-account", {
                href: `/#/redirect/${completeAccountUrl}`
              })
            )}
          </p>
          <p>{i18n.t("user.completing-allows")}</p>
        </div>
      );
    }
    let userBody;
    if (this.state.user) {
      let emailLocked =
        this.state.user.emailLocked ||
        (Mulligan.Brand.Account && Mulligan.Brand.Account.emailLocked);
      userBody = (
        <div>
          <h1>{i18n.t("base.user")}</h1>
          <h2>{i18n.t("user.personal-information")}</h2>
          <div className="deck">
            <form id="user-personal-info" onSubmit={this._onSubmit}>
              {this.state.setInfoError &&
                <FormAlert level="error">{this.state.setInfoError}</FormAlert>
              }
              {emailLocked ? (
                <div>
                  <div>
                    {i18n.t("user.email-locked-description")}&nbsp;
                    <a onClick={this._toggleEmailLockedModal}>
                      {i18n.t("base.learn-more")}.
                    </a>
                  </div>
                  {this.state.emailLockedModal && <Dialog
                    onRequestClose={this._toggleEmailLockedModal}
                    rootSelector="#root"
                    open
                    title={i18n.t("user.email-locked")}
                  >
                    <div>{i18n.t("user.email-locked-description")}</div>
                    <div>{i18n.t("user.email-locked-more")}</div>
                  </Dialog>}
                  <div className="locked-email">{this.state.email}</div>
                </div>
              ) : (
                  <TextField
                    label={i18n.t("base.email")}
                    type="email"
                    defaultValue={this.state.email}
                    required
                    fullWidth
                    nativeFormControlRef={x => { this.email = x }}
                  />
                )}
              <TextField
                label={i18n.t("user.first-name")}
                type="text"
                required
                defaultValue={this.state.firstName}
                fullWidth
                nativeFormControlRef={x => { this.firstName = x }}
              />
              <TextField
                label={i18n.t("user.last-name")}
                type="text"
                required
                defaultValue={this.state.lastName}
                fullWidth
                nativeFormControlRef={x => { this.lastName = x }}
              />
              <div className="user-save">
                <Button
                  type="submit"
                  disabled={this.state.settingInfo}
                >
                  {i18n.t("base.save")}
                </Button>
              </div>
            </form>
          </div>
          <h2>{i18n.t("user.security-information")}</h2>
          <div className="deck">
            <ul className="security-info-list">
              <li>
                {i18n.t("user.security-password")}
                <Button
                  onClick={this._changePassword}
                  label={i18n.t("user.security-info-change")}
                  naked
                >
                  {i18n.t("user.security-info-change")}
                </Button>
              </li>
              <li>
                {i18n.t("user.security-question")}
                <Button
                  onClick={this._changeSecurityQuestion}
                  label={i18n.t("user.security-info-change")}
                  naked
                >
                  {i18n.t("user.security-info-change")}
                </Button>
              </li>
            </ul>
          </div>
          {this.props.modalOpen === "change-password" && <Dialog
            rootSelector="#root"
            open
            formProps={{
              onSubmit: this._onUpdatePassword
            }}
            onRequestClose={this._hideModal}
            primaryActionButton={{
              label: i18n.t("base.save"),
              disabled: this.state.updatingPassword
            }}
            secondaryActionButton={{
              label: i18n.t("base.cancel"),
              onClick: this._hideModal
            }}
            title={i18n.t("user.change-password-title")}
          >
            {this.state.passwordChangeError &&
              <FormAlert level="error">{this.state.passwordChangeError}</FormAlert>
            }
            {Mulligan.Brand.Account.requireCurrentPassword && (
              <TextField
                label={i18n.t("user.current-password")}
                type="password"
                nativeFormControlRef={x => { this.currentPassword = x }}
                required
              />
            )}
            <TextField
              label={i18n.t("user.new-password")}
              helperText={i18n.t("user.new-password-tooltip")}
              validate={() => {
                if (!this._isValidPassword(this.password.value)) {
                  return i18n.t("user.change-password-text");
                }
              }}
              type="password"
              nativeFormControlRef={x => { this.password = x }}
              required
            />
            <TextField
              label={i18n.t("user.confirm-new-password")}
              validate={() => {
                if (this.passwordConfirmation.value !== this.password.value) {
                  return i18n.t("user.confirm-password-failure");
                }
              }}
              type="password"
              nativeFormControlRef={x => { this.passwordConfirmation = x }}
              required
            />
          </Dialog>}
          {this.props.modalOpen === "change-security-question" && <Dialog
            rootSelector="#root"
            open
            formProps={{
              onSubmit: this._onUpdateSecurityQuestion
            }}
            onRequestClose={this._hideModal}
            primaryActionButton={{
              label: i18n.t("base.save"),
              disabled: this.state.updatingSecurity
            }}
            secondaryActionButton={{
              label: i18n.t("base.cancel"),
              onClick: this._hideModal
            }}
            title={i18n.t("user.security-question")}
          >
            {this.state.securityError &&
              <FormAlert level="error">{this.state.securityError}</FormAlert>
            }
            <Select
              label={i18n.t("user.question")}
              nativeFormControlRef={x => { this.questionId = x }}
            >
              <option value="" />
              <option value={6}>
                {i18n.t("user.security-question6")}
              </option>
              <option value={7}>
                {i18n.t("user.security-question7")}
              </option>
              <option value={8}>
                {i18n.t("user.security-question8")}
              </option>
              <option value={9}>
                {i18n.t("user.security-question9")}
              </option>
              <option value={10}>
                {i18n.t("user.security-question10")}
              </option>
            </Select>
            <TextField
              label={i18n.t("user.answer")}
              required
              type="text"
              nativeFormControlRef={x => { this.questionResponse = x }}
            />
          </Dialog>}
        </div>
      );
    } else {
      userBody = (
        <div className="deck">
          <VstLoader delay={500}>{i18n.t("user.loading")}</VstLoader>
        </div>
      );
    }
    return <div className="page user">{userBody}</div>;
  }
});

export default User;
